<template>
  <div class="store-filter-group">
    <h3 class="store-filter-group__title">
      {{ group.name }}
    </h3>
    <ul class="store-filter-group__list">
      <li
        v-for="filter in activeFilters"
        :key="filter.id"
      >
        <CheckboxFilter :filter="filter" />
      </li>
    </ul>
  </div>
</template>

<script>
import CheckboxFilter from './CheckboxFilter'

export default {
  name: 'FilterGroup',

  components: {
    CheckboxFilter
  },

  props: {
    group: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    activeFilters () {
      const currentFilters = this.$store.state.currentFilters

      return this.group.filters.filter((filter) => {
        if (filter.hasOwnProperty('depends_on') && filter.depends_on.length) {
          if (filter.type === 'type') {
            return filter.depends_on.some(id => currentFilters.map(filter => filter.id).includes(id))
          } else {
            return filter.depends_on.every(id => currentFilters.map(filter => filter.id).includes(id))
          }
        }

        return true
      })
    }
  },

  methods: {
    setFilterOption (option, filter) {
      this.setCurrentFilterOption({
        option,
        filter
      });
    },

    filterId (id) {
      return `filter-${id}`
    }
  }
}
</script>
